import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

import PortfolioList from "./pages/PortfolioList";
import PortfolioDetail from "./pages/PortfolioDetail";
import Tentang from "./pages/Tentang";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        <Route
          path="/"
          element={<PortfolioList />}
        />

        <Route
          path="/portfolio/:id"
          element={<PortfolioDetail />}
        />


        <Route
          path="/tentang"
          element={<Tentang />}
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;